require('./brokerTransferValuesSuccessStep.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const { formatText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @ components
const BrokerTransferValuesSidebar = require('components/broker/brokerTransferValuesSidebar/brokerTransferValuesSidebar');

const BrokerTransferValuesSuccessStep = props => {
    const { immContractValues, immStocksContracts, immTransferValues } = props;
    const title = formatText('broker-transferValuesSuccessTitle');
    const goBackButtonLabel = formatText('broker-transferValuesBack');
    const linkToMovements = `/myprofile/broker`;
    const goBackButton = {
        label: goBackButtonLabel,
        url: linkToMovements
    };

    return (
        <article className="broker-transfer-values-success row no-gutter">
            <div className="col-xs-12">
                <WizardSuccess
                    successMessage={title}
                    mainButton={goBackButton}
                    customClassName="broker-transfer-values-success__wizard"
                >
                    <BrokerTransferValuesSidebar
                        immTransferValues={immTransferValues}
                        immContractValues={immContractValues}
                        immStocksContracts={immStocksContracts}
                        success={true}
                    />
                </WizardSuccess>
            </div>
        </article>
    )
};

BrokerTransferValuesSuccessStep.propTypes = {
    immTransferValues: PropTypes.object.isRequired,
    immContractValues: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired
}

module.exports = BrokerTransferValuesSuccessStep;